<ion-header
  role="none"
  class="map-header"
  [ngClass]="{ 'header-transparent': !isDevice }"
>
  <!--///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        MAIN HEADER
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
    <div class="container-lg">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button (click)="dismiss()" attr.aria-label="{{ 'ARIA_LABEL_BACK' | translate }}">
            <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
          </ion-button>
        </ion-buttons>

        <ion-title
          class="title-wrap"
          mode="ios"
          *ngIf="data.question && data.question.type === 'geocoder'"
        >
          <h6 role="heading" aria-level="1" *ngIf="data.item && data.item.text">{{ data.question.subtext }}</h6>
        </ion-title>

        <ion-title
          class="title-wrap"
          mode="ios"
          *ngIf="data.question && data.question.type === 'geocoders'"
        >
          <h6 role="heading" aria-level="1" *ngIf="data && data.item && data.item.text">
            {{ data.question.subtext }} {{ data.item.text }}
          </h6>
        </ion-title>

        <ion-buttons slot="end">
          <ion-button (click)="onClickHelp()" attr.aria-label="{{ 'ARIA_LABEL_HELP' | translate }}">
            <ion-icon slot="icon-only" name="help-circle-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>

      <!--///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            HEADER SEARCHBAR
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->

      <ion-toolbar>
        <app-address-search
          [mapLoaded]="mapLoaded"
          (addressSearchEvent)="onAddressSearchEvent($event)"
          (addressSearchResultUpdate)="onAddressSearchListEvent($event)"
        ></app-address-search>
      </ion-toolbar>
    </div>
</ion-header>

<!--///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    CONTENT
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->

<ion-content>

  <div #placesMap id="places-map" tabindex="-1" aria-hidden="true"></div>

  <div class="map-container">
    <div class="map-spinner" *ngIf="!mapLoaded">
      <ion-spinner></ion-spinner>
    </div>

    <div class="map-spacer"></div>
      <google-map
        #map
        id="map"
        tabindex="-1"
        class="container-lg"
        [ngClass]="{'hide-map': mapIsHidden}"
        (stateChangeEvent)="mapStateUpdate($event)"
      ></google-map>
    <div class="map-spacer"></div>



    <div *ngIf="showAddressDialog" class="map-search-address-container">
      <div class="prompt-container">
        <div
          class="prompt-label"
          [innerHTML]="'MAP_MAP_SEARCH_PROMPT' | translate"
        ></div>
        <div [innerHTML]="addressDialogText">
        </div>
      </div>
    </div>
  </div>
</ion-content>

<!--///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    FOOTER
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->

<ion-footer class="map-footer">
  <ion-button
    id="nextButton"
    expand="block"
    class="emphasized-button"
    (click)="next()"
    [disabled]="nextDisabled"
    [innerHTML]="'BUTTON_NEXT' | translate"
  ></ion-button>
</ion-footer>
